module.exports = __webpack_public_path__ + "img/HZGB12-20w.b6e4ded.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB12-20w.png
// module id = JFU4
// module chunks = 0